import { useContext } from 'react';
import { ThemeContext } from '../../app/providers/ThemeProvider';

/**
 * Custom hook to access theme context
 * @returns {{ theme: 'light' | 'dark', toggleTheme: () => void, setTheme: (theme: 'light' | 'dark') => void }}
 * @throws {Error} If used outside of ThemeProvider
 * 
 * @example
 * const { theme, toggleTheme, setTheme } = useTheme();
 * 
 * // Toggle between themes
 * toggleTheme();
 * 
 * // Set a specific theme
 * setTheme('dark');
 * 
 * // Check current theme
 * if (theme === 'dark') {
 *   // Dark theme specific logic
 * }
 */
export function useTheme() {
  const context = useContext(ThemeContext);
  
  if (!context) {
    throw new Error(
      'useTheme must be used within a ThemeProvider. ' +
      'Wrap your component tree with <ThemeProvider> to use this hook.'
    );
  }
  
  return context;
}

export default useTheme;
